module.exports = __webpack_public_path__ + "img/logo.77222825.png";